import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import type SignatureCanvasType from 'react-signature-canvas';
import { SavedSignatureNote } from '../V2Bits';
import type { StagedUpload } from '../types';

export function V2ConsentStep({ consentRequired, consentName, onNameChange, finalSigRef, onClearSig, staged }: {
  consentRequired: boolean;
  consentName: string;
  onNameChange: (v: string) => void;
  finalSigRef: React.RefObject<SignatureCanvasType | null>;
  onClearSig: () => void;
  staged?: StagedUpload;
}) {
  return (
    <div className="space-y-6">
      <div className="text-center mb-4">
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900">Final Authorization</h3>
        <p className="text-gray-500 text-sm mt-2">
          {consentRequired
            ? 'Please authorize your signatures with your legal name and drawing.'
            : 'You did not accept any of the agreements, so no authorization is needed. You can continue.'}
        </p>
      </div>
      {/* Nothing accepted → nothing to authorize: the screen is just the note
          above, so the step count stays stable without demanding a signature. */}
      {consentRequired && (
      <div className="space-y-4">
        <div>
          <label htmlFor="consent-name" className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-2 block">Type Full Name</label>
          <input
            id="consent-name"
            className="w-full bg-transparent border-b-2 border-gray-100 focus:border-primary text-xl sm:text-2xl py-2 outline-none transition-colors placeholder:text-gray-500"
            placeholder="Your legal name"
            autoComplete="name"
            autoCapitalize="words"
            enterKeyHint="done"
            value={consentName}
            onChange={(e) => onNameChange(e.target.value)}
          />
        </div>
        <div>
          <label className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-2 block">Draw Signature</label>
          <div className="relative border-2 border-gray-100 rounded-2xl overflow-hidden bg-white hover:border-primary/30 transition-colors">
            <SignatureCanvas
              ref={finalSigRef}
              penColor="black"
              clearOnResize={false}
              canvasProps={{ className: 'w-full h-44 sm:h-44 md:h-48', style: { touchAction: 'none' } }}
            />
            <div aria-hidden className="pointer-events-none absolute inset-x-5 bottom-5 border-b border-dashed border-gray-300" />
          </div>
          <button
            type="button"
            className="mt-2 min-h-[44px] px-4 rounded-xl border border-gray-200 bg-white text-sm font-semibold text-gray-500 hover:text-gray-700 hover:border-gray-300 transition-colors"
            onClick={onClearSig}
          >
            Clear
          </button>
          <SavedSignatureNote staged={staged} />
        </div>
      </div>
      )}
    </div>
  );
}
